// modifyUpdateAssignment — VQE-Edit edit-action: replace the value-text of an
// existing `UPDATE … SET col = value, …` assignment via SR-Edit's
// `modify-update-assignment` op. The target column (and the `=` itself) are
// preserved verbatim by SR-Edit; this module only validates the index +
// new value and delegates to `commitEdit`.
//
// PRD: Ralph/VisualQueryEditorEdit/PRD.md § Slice: Edit — DML edits.

import type { QueryStructure } from '../../../../sql-resolver/types/queryStructure';
import { commitEdit, type CommitEditCtx } from '../commitEdit';

export type ModifyUpdateAssignmentOptions = {
  /** Optional structure used for index-bounds validation. */
  readonly structure?: QueryStructure;
};

export async function modifyUpdateAssignment(
  index: number,
  newValueText: string,
  ctx: CommitEditCtx,
  options: ModifyUpdateAssignmentOptions = {},
): Promise<void> {
  if (!Number.isInteger(index) || index < 0) {
    throw new Error(
      `modifyUpdateAssignment: index must be a non-negative integer (got ${index})`,
    );
  }
  const v = newValueText.trim();
  if (v.length === 0) {
    throw new Error('modifyUpdateAssignment: newValueText must not be empty');
  }
  if (options.structure) {
    const items = options.structure.updateAssignments ?? [];
    if (items.length === 0) {
      throw new Error('modifyUpdateAssignment: SET list is empty');
    }
    if (index >= items.length) {
      throw new Error(
        `modifyUpdateAssignment: index ${index} out of range (SET list has ${items.length} item(s))`,
      );
    }
  }
  await commitEdit(
    { op: 'modify-update-assignment', index, newValueText: v },
    ctx,
  );
}
